import { Http } from 'infra/http';

export const makeHttpClient = (): Http => new Http();
